import "./_half-divided-block-styles.scss";

 import './half-divided-block';
